<template>
  <section>
    <bannertitle link_href="/about">
      <template slot="tag">关于佳能</template>
      <template slot="title">有关风险管理的管理层信息</template>
      <template slot="subtitle">日期：2024年9月3日</template>
    </bannertitle>
    <section class="banner_image">
      <div class="width_100">
        <picture class="width_100">
          <img src="@/assets/FFP/images/RiskInfo_Banner.png"
               alt="AboutCaRiskInfo_Bannernon_Banner.png"
               class="width_100">
        </picture>
      </div>
    </section>
    <section class="about_company">
      <div class="content_container">
        <div class="paragraph">&nbsp;</div>
        <div class="paragraph">佳能商务科技（广东）有限公司（「<span>公司</span>」）的管理团队致力于通过主动识别和系统管理可能对公司业务和运营产生重大影响的风险，确保公司的可持续增长和发展。</div>
        <div class="paragraph font_bold2">1. 风险管理的重要性和目标</div>
        <div class="paragraph paraindent">我们相信风险管理的重要性，其为保护公司免受可预见和不可预见事件可能产生负面影响或负担的关键防御。有效的风险管理在风险事件不可避免发生时亦有助加快我们的规划和恢复。</div>
        <div class="paragraph font_bold2">2. 风险管理系统</div>
        <div class="paragraph paraindent">根据我们对风险管理的态度，我们致力于建立风险管理系统，包括以下：</div>
        <div class="paragraph paraindent">(a) 风险管理政策</div>
        <div class="paragraph paraindent">(b) 风险管理管治</div>
        <div class="paragraph paraindent">(c) 风险识别</div>
        <div class="paragraph paraindent">(d) 风险管理活动</div>
        <div class="paragraph paraindent">(e) 风险管理评估和改善</div>
        <div class="paragraph paraindent">(f) 风险管理教育</div>
        <div class="paragraph paraindent">(g) 危机管理</div>
        <div class="paragraph font_bold2">3. 适应不断变化的状况</div>
        <div class="paragraph paraindent">我们周遭的业务、监管、环境和其他状况不时变化。在持续快速变化的时代，我们有必要通过我们的风险管理活动来适应和及时应对变化。</div>
        <div class="paragraph font_bold2">4. 持续审视和改善</div>
        <div class="paragraph paraindent">我们将通过定期审视系统来持续改善我们的风险管理系统，以确保充分实现其目标。</div>
        <div class="paragraph font_right_1">李冠德</div>
        <div class="paragraph font_right_2">董事长及法定代表人</div>
        <div class="paragraph font_right_3">佳能商务科技（广东）有限公司</div>
        <div class="paragraph">&nbsp;</div>
      </div>
      <div></div>
    </section>
    <learnmore :option="learn_option">
      <template slot="line_one">了解更多佳能产品及解决方案</template>
      <template slot="learn_more_button">联络我们</template>
    </learnmore>
  </section>
</template>
<script>
import bannertitle from './bannertitle'
import learnmore from '../LearnMore'
export default {
  name: 'CompanyProfile',
  components: { bannertitle, learnmore },
  props: [
    'belongTo'
  ],
  data () {
    return {
      learn_option: {
        backgroundColor: '#505050',
        fontColor: 'white'
      }
    }
  },
  methods: {
  },
  created () {
  },
  mounted () {
  }
}
</script>
<style scoped lang="scss" src='../../assets/FFP/css/Article.scss'>
</style>
<style scoped lang="scss">
$p-size: 32px;
$p-size-small: 24px;
$span-size: 20px;
$span-size-small: 16px;
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

a {
  text-decoration: none;
}

.banner_image {
  width: 100%;
}
.width_100 {
  width: 100%;
}

.width_50 {
  width: 50%;
}

.background_color_gray {
  background-color: #ebebeb;
}
.background_color_white {
  background-color: #ffffff;
}
.about_company {
}
.about_company .article_contioner {
  width: 100%;
  padding: 100px 300px;
}

.about_company .article_image {
  background: linear-gradient(
    #ffffff 0%,
    #ffffff 29%,
    #ffffff 30%,
    #eceded 30%,
    #ebebeb 100%
  );
}
.about_company .article_image img {
  width: 50%;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
}
.about_company .article_contioner .article_title {
  font-size: 36px;
  font-weight: 600;
  text-align: center;
  margin-bottom: 50px;
}
.about_company .article_contioner .article_text {
  font-size: 24px;
  font-weight: 600;
  color: #414141;
}
.about_company .article_contioner .article_text p {
  margin-bottom: 20px;
}

@media (min-width: 544px) and (max-width: 1200px) {
  .about_company .article_contioner {
    padding: 80px 100px;
  }
  .about_company .article_image img {
    width: 70%;
  }
}

@media (max-width: 544px) {
  .about_company .article_contioner {
    padding: 20px 40px;
  }
  .about_company .article_image img {
    width: 70%;
  }
  .about_company .article_contioner .article_title {
    font-size: 24px;
    margin-bottom: 10px;
  }
  .about_company .article_contioner .article_text {
    font-size: 18px;
  }
}

.milestone_title {
  margin: 100px;
  font-size: 36px;
  font-weight: 600;
  text-align: center;
}

@media (max-width: 544px) {
  .milestone_title {
    margin: 40px;
    font-size: 24px;
  }
}

.milestone {
  position: relative;
  width: 75%;
  left: 50%;
  transform: translateX(-50%);
}

@media (max-width: 1200px) {
  .milestone {
    width: 90%;
  }
}

.milestone_line {
  position: absolute;
  left: 9px;
  height: 100%;
  border-left: 2px solid #f2524e;
}
.milestone_item {
  position: relative;
  padding-top: 20px;
}

.milestone_time {
  font-size: 36px;
  color: #f2524e;
  position: relative;
  top: 0px;
  left: -5px;
  background-color: #ffffff;
  margin: 10px 10px 10px 0;
}

.milestone_circle {
  height: 20px;
  width: 20px;
  border: 2px solid #f2524e;
  border-radius: 50%;
  position: absolute;
  top: 30%;
  background-color: #ffffff;
}
.milestone_image img {
  height: 200px;
}

@media (min-width: 544px) and (max-width: 768px) {
  .milestone_image img {
    height: 150px;
  }
}

@media (max-width: 544px) {
  .milestone_image img {
    height: 80px;
  }
}
.milestone_article {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-bottom: 20px;
  border-bottom: 2px solid #ebebeb;
  margin: 0 100px;
}

@media (min-width: 544px) and (max-width: 1200px) {
  .milestone_article {
    margin: 0 50px;
  }
}

@media (max-width: 544px) {
  .milestone_article {
    margin: 0 30px;
  }
}

.milestone_article .milestone_text {
  font-size: 24px;
  margin-left: 50px;
}

@media (min-width: 544px) and (max-width: 768px) {
  .milestone_article .milestone_text {
    font-size: 18px;
    margin-left: 20px;
  }
}
@media (max-width: 544px) {
  .milestone_article .milestone_text {
    font-size: 14px;
    margin-left: 10px;
  }
}
.font_size_32px {
  font-size: 32px;
}
</style>



// WEBPACK FOOTER //
// src/components/Article/RiskInfo.vue